import en from "./en.json";

export const i18n = { en } as {
  [key: string]: Record<string, any>;
};
